import { apiGet, apiPost } from "./client";

export function getOffersForUser({ userId, packageName }) {
  const params = new URLSearchParams();
  if (userId) params.append("userId", userId);
  if (packageName) params.append("packageName", packageName);
  const query = params.toString();
  const path = query ? `/offersForUser?${query}` : "/offersForUser";
  return apiGet(path);
}

export function getAllAppsForUser({ userId, siteUserId, packageName, language, token }) {
  const params = new URLSearchParams();
  if (userId) params.append("userId", userId);
  if (siteUserId) params.append("siteUserId", siteUserId);
  if (packageName) params.append("packageName", packageName);
  if (language) params.append("language", language);
  const query = params.toString();
  const path = query ? `/getOfferwallConfig?${query}` : "/getOfferwallConfig";

 
  const headers = token ? { Authorization: `Bearer ${token}` } : undefined;
  return apiGet(path, { headers });
}

export function getOfferwallConfigByApiKey({ apiKey, userId, siteUserId, packageName, language }) {
  const params = new URLSearchParams();
  if (apiKey) params.append("apiKey", apiKey);
  if (userId) params.append("userId", userId);
  if (siteUserId) params.append("siteUserId", siteUserId);
  if (packageName) params.append("packageName", packageName);
  if (language) params.append("language", language);
  const query = params.toString();
  const path = query ? `/getOfferwallConfigByApiKey?${query}` : "/getOfferwallConfigByApiKey";
  return apiGet(path);
}

export function startOfferwallOffer({ userId, packageName, siteUserId }) {
  const body = {
    userId,
    packageName,
    siteUserId,
  };
  return apiPost("/startOfferwallOffer", body);
}

export function deactivateOfferForUser({ userId, siteUserId, appName }) {
  const body = {
    userId,
    siteUserId,
    appName,
  };
  return apiPost("/deactivateOffer", body);
}

export function openChest({ userId, siteUserId, packageName, appName, offerConvertId, appId }) {
  const body = {
    userId,
    siteUserId,
    packageName,
    appName,
    offerConvertId,
    appId,
  };
  return apiPost("/openChest", body);
}
